import React, { useCallback, useMemo, useState } from 'react';
import { Box, Text, Thumbnail, Button, Image } from '@wix/design-system';
import Illustration from './illustration.svg';
import s from './AssetsPickerWidget.scss';
import { ASSETS_PICKER_WIDGET } from '../consts';
import { useDisabledWidget } from '../../../../shared/disabled-widget/useDisabledWidget';
export const AssetsPickerWidget = _ref => {
  let {
    data: {
      widgetLabel,
      assetsList,
      primaryButton,
      assetsTypesToLabels
    },
    context: {
      send,
      onWidgetAction,
      emitSideEffect
    },
    config
  } = _ref;
  const [selected, setSelected] = useState([]);
  const [hasLandingPage, setHasLandingPage] = useState(false);
  const {
    areControlsDisabled
  } = useDisabledWidget(config);
  const toggleSelection = useCallback(title => {
    setSelected(prevSelected => {
      const newSelected = prevSelected.some(asset => asset.title === title) ? prevSelected.filter(asset => asset.title !== title) : [...prevSelected, assetsList.find(asset => asset.title === title)];
      setHasLandingPage(newSelected.some(asset => asset.type === 'LANDING_PAGE'));
      return newSelected;
    });
  }, [assetsList]);
  const groupedAssets = useMemo(() => {
    return assetsList.reduce((acc, asset) => {
      const type = assetsTypesToLabels[asset.type];
      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(asset);
      return acc;
    }, {});
  }, [assetsList, assetsTypesToLabels]);
  const handleWidgetAction = useCallback(() => {
    onWidgetAction == null || onWidgetAction(ASSETS_PICKER_WIDGET, {
      action: primaryButton.buttonName,
      value: selected
    });
    send(`${primaryButton.respondText}  ${selected.map(asset => asset.title).join(', ')}`);
    emitSideEffect(primaryButton.sideEffectName, selected);
  }, [selected, primaryButton, onWidgetAction, send, emitSideEffect]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px",
    paddingTop: "SP1",
    paddingBottom: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "normal",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, widgetLabel), Object.entries(groupedAssets).map(_ref2 => {
    let [type, assets] = _ref2;
    return /*#__PURE__*/React.createElement(Box, {
      gap: "6px",
      key: type,
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "thin",
      skin: areControlsDisabled ? 'disabled' : undefined
    }, type), /*#__PURE__*/React.createElement("div", {
      className: s.flexContainer
    }, assets.map(_ref3 => {
      let {
        title,
        illustrationUrl
      } = _ref3;
      return /*#__PURE__*/React.createElement(Thumbnail, {
        disabled: areControlsDisabled,
        className: s.flexItem,
        selected: selected.some(asset => asset.title === title),
        onClick: () => toggleSelection(title),
        key: title
      }, /*#__PURE__*/React.createElement(Box, {
        padding: "12px",
        gap: "12px"
      }, illustrationUrl ? /*#__PURE__*/React.createElement(Image, {
        width: "48px",
        height: "48px",
        src: illustrationUrl,
        alt: title,
        transparent: true
      }) : /*#__PURE__*/React.createElement(Illustration, null), /*#__PURE__*/React.createElement(Box, {
        gap: "12px",
        verticalAlign: "middle"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small",
        weight: "bold",
        skin: areControlsDisabled ? 'disabled' : undefined
      }, title))));
    })));
  }), /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    disabled: areControlsDisabled || selected.length === 0 || !hasLandingPage,
    onClick: handleWidgetAction,
    className: s.button
  }, primaryButton.label));
};
//# sourceMappingURL=AssetsPickerWidget.js.map